<template lang="pug">
#footer
  footer.grey-back
    .container-fluid
      .row.py-5.justify-content-center
        .col.col-sm-auto.py-3.d-flex.justify-content-center
          img.logo(src="/assets/logos/LOGO-DGFII_PDH.png")
        .col.col-sm-auto.py-3.d-flex.justify-content-center
          img.logo(src="/assets/logos/Logo Data Cívica.svg")
        .col.col-sm-auto.py-3.d-flex.justify-content-center
          img.logo(src="/assets/logos/ESCUDO IBERO.bmp")
        .col.col-sm-auto.py-3.d-flex.justify-content-center
          img.logo(src="/assets/logos/dcsh.jpg")
        .col.col-sm-auto.py-3.d-flex.justify-content-center
          img.logo(src="/assets/logos/HRDAG.png")
        .col.col-sm-auto.py-3.d-flex.justify-content-center
          img.logo(src="/assets/logos/sembrando.jpeg")
        .col.col-sm-auto.py-3.d-flex.justify-content-center
          img.logo(src="/assets/logos/colectivos.jpg")
        .col.col-sm-auto.py-3.d-flex.justify-content-center
          img.logo(src="/assets/logos/article19_logo1.png")
        .col.col-sm-auto.py-3.d-flex.justify-content-center
          img.logo(src="/assets/logos/cmdpdh-logo-color-v1.png")
        .col.col-sm-auto.py-3.d-flex.justify-content-center
          img.logo(src="/assets/logos/poplab.jpg")



</template>

<script>
export default {
  name: "footer"
};
</script>

<style lang="scss">
#footer {
  .logo {
    height: 40px;
  }
}
</style>
